var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableChairFError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10.009,
  cy: 10,
  r: 7.2,
  fill: "#464D57"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M16.209 10a6.2 6.2 0 1 1-12.4 0c0-.039.012-.074.056-.114a.378.378 0 0 1 .249-.086h11.79c.11 0 .197.04.248.086.044.04.057.075.057.114Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M4.917 4.909a7.2 7.2 0 0 1 10.183 0"
})));
SvgNoTableChairFError.viewBox = '0 0 20 20';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableChairFError);
export default ForwardRef;